import styled from 'styled-components';

export const Wrapper = styled.header`
  position: fixed;
  z-index: 999;
  background: var(--color-page);
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  padding: 40px 16px 24px;

  .opened {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: var(--color-page);
    padding: 40px 16px 24px;

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .menu {
      display: flex;
      gap: 16px;
      padding: 20px 0 0;

      .white-button {
        border-color: var(--color-surface);
        color: var(--color-surface);
      }
    }
  }

  .primary-button {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-radius: 5px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    background: linear-gradient(90deg, var(--color-gradient-from) 0%, var(--color-gradient-to) 100%);
    border: none;
    color: var(--color-fixed-white);
    white-space: nowrap;
    &:hover {
      background: linear-gradient(90deg, var(--color-banner-gradient-from) 0%, var(--color-banner-gradient-to) 100%);
    }
  }

  .white-button {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-radius: 5px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    color: var(--color-text-muted);
    white-space: nowrap;
    border: 1px solid var(--color-divider);
    background: none;
    &:hover {
      border: 1px solid var(--color-logo);
      color: var(--color-logo);
    }
  }

  .link-button {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-radius: 5px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    white-space: nowrap;
    background: none;
    border: none;
    color: var(--color-title);
    &:hover {
      text-decoration: underline;
    }
  }
`;
